import localforage from "localforage"

/**
 * getMPXUserInfo - Retrieve MPX user object form local storage
 *
 * @return {Promise}
 */
export function getMPXUserInfo() {
  return localforage
    .getItem("mpxUserInfo")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setMPXUserInfo - Set MPX user object in to local storage
 *
 * @param  {object} signInResponse Response object form MPX sign In
 * @return {Promise}
 */
export function setMPXUserInfo(signInResponse) {
  return localforage
    .setItem("mpxUserInfo", signInResponse)
    .then(() => {
      return localforage
        .getItem("mpxUserInfo")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getMVATSAuthorizeInfo - Retrieve MPX authorization object for 'MVATS' service from local storage
 *
 * @return {Promise}
 */
export function getMVATSAuthorizeInfo() {
  return localforage
    .getItem("mvatsAuthorizeInfo")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setMVATSAuthorizeInfo - Set MPX authorization object for "MVATS' service in to local storage
 *
 * @param  {object} authorizeResponse Response object form MPX authorization In
 * @return {Promise}
 */
export function setMVATSAuthorizeInfo(authorizeResponse) {
  return localforage
    .setItem("mvatsAuthorizeInfo", authorizeResponse)
    .then(() => {
      return localforage
        .getItem("mvatsAuthorizeInfo")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getOpsUIAuthorizeInfo - Retrieve MPX authorization object for 'Operation UI' service from local storage
 *
 * @return {Promise}
 */
export function getOpsUIAuthorizeInfo() {
  return localforage
    .getItem("opsUIAuthorizeInfo")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setOpsUIAuthorizeInfo - Set MPX authorization object for 'Operation UI' service in to local storage
 *
 * @param  {object} authorizeResponse Response object form MPX authorization In
 * @return {Promise}
 */
export function setOpsUIAuthorizeInfo(authorizeResponse) {
  return localforage
    .setItem("opsUIAuthorizeInfo", authorizeResponse)
    .then(() => {
      return localforage
        .getItem("opsUIAuthorizeInfo")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getMPXParentAccountInfo - Retrieve MVATS parent account from local storage
 *
 * @return {Promise}
 */
export function getMPXParentAccountInfo() {
  return localforage
    .getItem("mpxParentAccountInfo")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setMPXParentAccountInfo - Set MVATS parent account in to local storage
 *
 * @param  {object} mpxAccount selected mpx account
 * @return {Promise}
 */
export function setMPXParentAccountInfo(mpxAccount) {
  return localforage
    .setItem("mpxParentAccountInfo", mpxAccount)
    .then(() => {
      return localforage
        .getItem("mpxParentAccountInfo")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getServiceRegistry - retrieve service registry from local storage
 * @return {Promise}
 */
export function getServiceRegistry() {
  return localforage
    .getItem("mpxServiceRegistry")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setServiceRegistry - Set service registry
 *
 * @param  {object} services Services array
 * @return {Promise}
 */
export function setServiceRegistry(services) {
  return localforage
    .setItem("mpxServiceRegistry", services)
    .then(() => {
      return localforage
        .getItem("mpxServiceRegistry")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getMPXSubAccounts - retrieve mpx sub accounts from local storage
 * @return {Promise}
 */
export function getMPXSubAccounts() {
  return localforage
    .getItem("mpxSubAccounts")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setMPXSubAccounts - Set sub accounts
 *
 * @param  {object} subAccounts Sub Accounts array
 * @return {Promise}
 */
export function setMPXSubAccounts(subAccounts) {
  return localforage
    .setItem("mpxSubAccounts", subAccounts)
    .then(() => {
      return localforage
        .getItem("mpxSubAccounts")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getCableUserInfo - Retrieve user object of user logged in with CABLE
 * from local storage
 *
 * @return {Promise}
 */
export function getCableUserInfo() {
  return localforage
    .getItem("cableUserInfo")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setCableUserInfo - Set user object of user logged in with CABLE in to
 * local storage
 *
 * @param  {type} userInfo User info object along with tokens retrieved
 * from SSO authorization
 * @return {Promise}
 */
export function setCableUserInfo(userInfo) {
  return localforage
    .setItem("cableUserInfo", userInfo)
    .then(() => {
      return localforage
        .getItem("cableUserInfo")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * getRedirectPath - Retrieve user redirection path
 * from local storage
 *
 * @return {Promise}
 */
export function getRedirectPath() {
  return localforage
    .getItem("redirectPath")
    .then(value => {
      return value
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/**
 * setRedirectPath - Set user redirection path
 * local storage
 *
 * @param  {string} pathName Redirect path name
 * from SSO authorization
 * @return {Promise}
 */
export function setRedirectPath(pathName) {
  return localforage
    .setItem("redirectPath", pathName)
    .then(() => {
      return localforage
        .getItem("redirectPath")
        .then(value => {
          return value
        })
        .catch(error => {
          return Promise.reject(error)
        })
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./src/AppDataService.js